import React from 'react';
import './design.styles.scss';

const Design = () => {
  return (
    <div className="design-container">
      <div className="service-header">
        <h1>Database Design & Architecture</h1>
        <p>Strategic database design for optimal performance and scalability</p>
      </div>

      <div className="service-content">
        <section className="service-overview">
          <h2>Expert Database Architecture</h2>
          <p>
            Our database design services focus on creating efficient, scalable, and maintainable 
            database structures that support your business objectives. We employ best practices 
            in data modeling, normalization, and performance optimization.
          </p>
        </section>

        <section className="service-features">
          <h2>Design Services Include:</h2>
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon">📊</div>
              <h3>Schema Design</h3>
              <p>Comprehensive database schema design with proper table structures and relationships.</p>
            </div>
            
            <div className="feature-card">
              <div className="feature-icon">🔗</div>
              <h3>Data Modeling</h3>
              <p>Conceptual, logical, and physical data modeling for complex business requirements.</p>
            </div>
            
            <div className="feature-card">
              <div className="feature-icon">⚡</div>
              <h3>Performance Optimization</h3>
              <p>Index design and query optimization strategies for maximum performance.</p>
            </div>
            
            <div className="feature-card">
              <div className="feature-icon">🔄</div>
              <h3>Normalization</h3>
              <p>Proper database normalization to eliminate redundancy and improve data integrity.</p>
            </div>
          </div>
        </section>

        <section className="contact-section">
          <h2>Ready to Design Your Database?</h2>
          <p>Contact us to discuss your database design requirements.</p>
          <button className="contact-btn">Get Started</button>
        </section>
      </div>
    </div>
  );
};

export default Design;